export default __webpack_public_path__ + "static/media/customize.a3aced7d.png";